<template>
  <div class="relative h-screen max-w-full overflow-y-scroll text-white text-center" id="viewer">
    <component :is="image.type+'-hero'" v-for="(image,index) in images"
               :key="index"
               :project="project"
               :picture="image"
               :picture_index="picture_index"
               :pictures_length="(images.length - 1)"
               :from_name="fromName"
    />

    <div v-if="$route.path==='/'" class="h-screen w-full flex items-center justify-center p-6"
         style="scroll-snap-align: start">
      <div class="mx-auto">
        <div>
          <span class="font-bold text-2xl">{{ $store.state.posts['outro'].title[locale()] }}</span> <br>
          <div v-html="$store.state.posts['outro'].body[locale()]"></div>
        </div>
        <div class="mt-4 flex flex-wrap w-full justify-around">
          <div class="w-full md:w-1/2 mb-4">
            <router-link to="projects/residential"
                         class="text-xs text-gray-600 hover:text-white font-bold border border-gray-600 rounded px-2 py-1 mr-2 uppercase">
              {{ t('residential') }}
            </router-link>
          </div>
          <div class="w-full md:w-1/2">
            <router-link to="projects/commercial"
                         class="text-xs text-gray-600 hover:text-white font-bold border border-gray-600 rounded px-2 py-1 uppercase">
              {{ t('commercial') }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ProjectHero from "../components/ProjectHero";
import CoverHero from "../components/CoverHero";
import ProjectPhotoHero from "../components/ProjectPhotoHero";

export default {
  components: {ProjectHero, CoverHero, ProjectPhotoHero},
  name: 'project-viewer',
  props: {
    project: {
      type: [Object, null],
      default: null
    },
    images: {
      type: [Array, Object],
      required: true
    }
  },
  data() {
    return {
      fromName: ''
    }
  },
  computed: {
    picture_index() {
      return this.images.findIndex((item) => {
        return item.path === this.$store.state.activeImagePath;
      });
    },
    progress() {
      let index = this.picture_index;
      if (index === 0) {
        return '0%';
      }
      return ((index) / (this.images.length - 1)) * 100 + '%';
    }
  },
  methods: {},
  mounted() {
      this.$nextTick(()=>{
        document.getElementById('viewer').scrollTop =this.$store.state.savedPositions[this.$route.path + '_scroll'] || 0;
      });
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fromName = from.name !== null ? from.name : 'home'
    });
  }
}
</script>

<style lang="scss" scoped>
.no-webp .img-main {
  /*background-image:url('/img/main_lg.jpg');*/
  /*background-size: cover;*/
  /*background-position: center;*/
}

.webp .img-main {
  /*background-image:url('/img/main_lg.webp');*/
  /*background-size: cover;*/
  /*background-position: center;*/
}

.progress {
  transition: width 0.5s ease-in;
  height: 2px;
}

#viewer {
  //scroll-snap-type: mandatory;
  //scroll-snap-points-y: repeat(3rem);
  //scroll-snap-type: y mandatory;
}
</style>